import createOrdersAtom from './orders.js';
import createFirstMissAtAtom from './first-miss-at.js';
export const ordersAtomDefinition = {
    id: 'ordersAtom',
    type: 'atom',
    factory: createOrdersAtom,
    dependencies: ['storage', 'assetsModule', 'logger'],
    public: true,
};
export const firstMissAtAtomDefinition = {
    id: 'firstMissAtAtom',
    type: 'atom',
    factory: createFirstMissAtAtom,
    dependencies: ['storage'],
};
